var _ellipse, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 95,
    viewBox: "0 0 94 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_98",
    cx: 47,
    cy: 47.5,
    rx: 47,
    ry: 47.5,
    fill: "#7c6eb0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_443",
    transform: "translate(19.704 27.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_129",
    d: "M2.4,0h50.46a2.4,2.4,0,0,1,2.4,2.4V28.834a2.4,2.4,0,0,1-2.4,2.4H2.4a2.4,2.4,0,0,1-2.4-2.4V2.4A2.4,2.4,0,0,1,2.4,0Z",
    transform: "translate(0 4.29)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_99",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(17.296 9.729)",
    fill: "#7c6eb0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_263",
    width: 14,
    height: 7,
    rx: 1,
    transform: "translate(33.296 -0.271)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.d0d260c05d9378c7a1bff2ccb9d0a0fd.svg";
export { ForwardRef as ReactComponent };